module.exports = __webpack_public_path__ + "img/people.75a98040.jpg";